import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../pages/Home";
import DocumentViewerPage from "../pages/DocumentViewer";
import QrCodeViewerPage from "../pages/QrCodeViewer";
import RecordInvoicePage from "../pages/RecordInvoice";
import { ErrorsPage } from "../modules/errors/ErrorsPage";
import { HANDOFF_VIEW_PARAM, consumeHandoffToken } from "../modules/utils/documentDownload";

const AppRoute = () => {
  // Bootstrap token from URL (_t param) for LINE → external browser handoff
  // Must run before any child component mounts and calls the API
  consumeHandoffToken();

  // Handoff pages arrive on "/" (see openInExternalBrowser) and need no router.
  const handoffView = new URLSearchParams(window.location.search).get(HANDOFF_VIEW_PARAM);
  if (handoffView === "qr") return <QrCodeViewerPage />;
  if (handoffView === "document") return <DocumentViewerPage />;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="document-viewer" element={<DocumentViewerPage />} />
        <Route path="qr-viewer" element={<QrCodeViewerPage />} />
        <Route
          path="record-invoice"
          element={<RecordInvoicePage />}
        />
        {/* error */}
        <Route path="error/*" element={<ErrorsPage />} />

        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoute;
